import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "./basequery";
export const api = createApi({
  baseQuery: apiBaseQuery,
  tagTypes: [],
  endpoints: (build) => ({
    getSiteMapsettings: build.query<
      GetSiteMapsettingsApiResponse,
      GetSiteMapsettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/mapsettings/`,
      }),
    }),
    getSiteGuide: build.query<GetSiteGuideApiResponse, GetSiteGuideApiArg>({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/guide/${queryArg.guideId}/`,
        params: { lang: queryArg.lang },
      }),
    }),
    search: build.query<SearchApiResponse, SearchApiArg>({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/guide/${queryArg.guideId}/search/`,
        params: { search: queryArg.search, lang: queryArg.lang },
      }),
    }),
    getRoute: build.query<GetRouteApiResponse, GetRouteApiArg>({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/route/${queryArg.routeId}/`,
        params: { lang: queryArg.lang },
      }),
    }),
    getRouteMapsettings: build.query<
      GetRouteMapsettingsApiResponse,
      GetRouteMapsettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/route/${queryArg.routeId}/mapsettings/`,
      }),
    }),
    getRouteImages: build.query<
      GetRouteImagesApiResponse,
      GetRouteImagesApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/route/${queryArg.routeId}/images/`,
      }),
    }),
    getRouteNearestTrail: build.query<
      GetRouteNearestTrailApiResponse,
      GetRouteNearestTrailApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/route/${queryArg.routeId}/waypoint/${queryArg.quadhash}/nearesttrail/`,
      }),
    }),
    getTrail: build.query<GetTrailApiResponse, GetTrailApiArg>({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/trail/${queryArg.trailUuid}/`,
        params: { lang: queryArg.lang },
      }),
    }),
    getTrailImages: build.query<
      GetTrailImagesApiResponse,
      GetTrailImagesApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/trail/${queryArg.trailUuid}/images/`,
      }),
    }),
    getTrailProfile: build.query<
      GetTrailProfileApiResponse,
      GetTrailProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/trail/${queryArg.trailUuid}/profile/`,
      }),
    }),
    getTrailWaypointConnection: build.query<
      GetTrailWaypointConnectionApiResponse,
      GetTrailWaypointConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/trail/${queryArg.trailUuid}/waypoint/${queryArg.quadhash}/connection/`,
      }),
    }),
    getStepDetails: build.query<
      GetStepDetailsApiResponse,
      GetStepDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/trail/${queryArg.trailUuid}/step/${queryArg.stepId}/`,
        params: { lang: queryArg.lang },
      }),
    }),
    getStepAmenities: build.query<
      GetStepAmenitiesApiResponse,
      GetStepAmenitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/trail/${queryArg.trailUuid}/step/${queryArg.stepId}/amenities/${queryArg.amenitiesType}/`,
        params: { page: queryArg.page, lang: queryArg.lang },
      }),
    }),
    getWaypoints: build.query<GetWaypointsApiResponse, GetWaypointsApiArg>({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/waypoint/list/`,
        params: {
          search: queryArg.search,
          quadhashs: queryArg.quadhashs,
          lang: queryArg.lang,
        },
      }),
    }),
    getWaypoint: build.query<GetWaypointApiResponse, GetWaypointApiArg>({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/waypoint/${queryArg.quadhash}/`,
        params: { lang: queryArg.lang },
      }),
    }),
    getWaypointAmenities: build.query<
      GetWaypointAmenitiesApiResponse,
      GetWaypointAmenitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/waypoint/${queryArg.quadhash}/amenities/${queryArg.amenitiesType}/`,
        params: { page: queryArg.page, lang: queryArg.lang },
      }),
    }),
    getPoi: build.query<GetPoiApiResponse, GetPoiApiArg>({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/poi/${queryArg.id}/`,
        params: { lang: queryArg.lang },
      }),
    }),
    getAccommodations: build.query<
      GetAccommodationsApiResponse,
      GetAccommodationsApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/accommodation/list/`,
        params: {
          quadhash: queryArg.quadhash,
          route_id: queryArg.routeId,
          trail_id: queryArg.trailId,
          step_id: queryArg.stepId,
          page: queryArg.page,
          order: queryArg.order,
          availability: queryArg.availability,
          lang: queryArg.lang,
        },
      }),
    }),
    getAccommodation: build.query<
      GetAccommodationApiResponse,
      GetAccommodationApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/accommodation/${queryArg.id}/`,
        params: { availability: queryArg.availability, lang: queryArg.lang },
      }),
    }),
    createTrail: build.query<CreateTrailApiResponse, CreateTrailApiArg>({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/trail/${queryArg.trailUuid}/action/create/${queryArg.start}/${queryArg.stop}/`,
      }),
    }),
    addTrailCheckpoint: build.query<
      AddTrailCheckpointApiResponse,
      AddTrailCheckpointApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/trail/${queryArg.trailUuid}/action/add/${queryArg.quadhash}/${queryArg.position}/`,
      }),
    }),
    addRouteCheckpoint: build.query<
      AddRouteCheckpointApiResponse,
      AddRouteCheckpointApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/route/${queryArg.routeId}/trail/${queryArg.trailId}/action/add/${queryArg.quadhash}/${queryArg.position}/`,
      }),
    }),
    removeRouteCheckpoint: build.query<
      RemoveRouteCheckpointApiResponse,
      RemoveRouteCheckpointApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/route/${queryArg.routeId}/trail/${queryArg.trailId}/action/remove/${queryArg.position}/`,
      }),
    }),
    splitRouteTrail: build.query<
      SplitRouteTrailApiResponse,
      SplitRouteTrailApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/route/${queryArg.routeId}/trail/${queryArg.trailId}/action/split/${queryArg.quadhash}/${queryArg.position}/`,
      }),
    }),
    setRouteTrailStop: build.query<
      SetRouteTrailStopApiResponse,
      SetRouteTrailStopApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/route/${queryArg.routeId}/trail/${queryArg.trailId}/action/setstops/${queryArg.quadhash}/`,
      }),
    }),
    setRouteTrailStart: build.query<
      SetRouteTrailStartApiResponse,
      SetRouteTrailStartApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/route/${queryArg.routeId}/trail/${queryArg.trailId}/action/setstart/${queryArg.quadhash}/`,
      }),
    }),
    updateRouteTrailCheckpoint: build.query<
      UpdateRouteTrailCheckpointApiResponse,
      UpdateRouteTrailCheckpointApiArg
    >({
      query: (queryArg) => ({
        url: `/1.0/json/${queryArg.siteId}/route/${queryArg.routeId}/trail/${queryArg.trailId}/action/update/${queryArg.quadhash}/${queryArg.position}/`,
      }),
    }),
  }),
});
export type GetSiteMapsettingsApiResponse =
  /** status 200 OK */ MapSettingsSchema;
export type GetSiteMapsettingsApiArg = {
  siteId: number;
};
export type GetSiteGuideApiResponse = /** status 200 OK */ GuideSchema;
export type GetSiteGuideApiArg = {
  siteId: number;
  guideId: number;
  lang: "it" | "en" | "en-us" | "es";
};
export type SearchApiResponse = /** status 200 OK */ SearchResultSchema[];
export type SearchApiArg = {
  siteId: string;
  guideId: string;
  search?: string;
  lang: "it" | "en" | "en-us" | "es";
};
export type GetRouteApiResponse = /** status 200 OK */ RouteDetailsSchema;
export type GetRouteApiArg = {
  siteId: number;
  routeId: string;
  lang: "it" | "en" | "en-us" | "es";
};
export type GetRouteMapsettingsApiResponse =
  /** status 200 OK */ MapSettingsSchema;
export type GetRouteMapsettingsApiArg = {
  siteId: number;
  routeId: string;
};
export type GetRouteImagesApiResponse = /** status 200 OK */ ImagesSchema[];
export type GetRouteImagesApiArg = {
  siteId: number;
  routeId: string;
};
export type GetRouteNearestTrailApiResponse =
  /** status 200 OK */ RouteNearestTrailSchema;
export type GetRouteNearestTrailApiArg = {
  siteId: number;
  routeId: string;
  quadhash: string;
};
export type GetTrailApiResponse = /** status 200 OK */ TrailDetailsSchema;
export type GetTrailApiArg = {
  siteId: number;
  trailUuid: string;
  lang: "it" | "en" | "en-us" | "es";
};
export type GetTrailImagesApiResponse = /** status 200 OK */ ImagesSchema[];
export type GetTrailImagesApiArg = {
  siteId: number;
  trailUuid: string;
};
export type GetTrailProfileApiResponse = /** status 200 OK */ ProfileSchema[];
export type GetTrailProfileApiArg = {
  siteId: number;
  trailUuid: string;
};
export type GetTrailWaypointConnectionApiResponse =
  /** status 200 OK */ TrailConnectionSchema;
export type GetTrailWaypointConnectionApiArg = {
  siteId: number;
  trailUuid: string;
  quadhash: string;
};
export type GetStepDetailsApiResponse = /** status 200 OK */ StepDetailsSchema;
export type GetStepDetailsApiArg = {
  siteId: number;
  trailUuid: string;
  stepId: number;
  lang: "it" | "en" | "en-us" | "es";
};
export type GetStepAmenitiesApiResponse =
  /** status 200 OK */ PaginateAmenitySchema;
export type GetStepAmenitiesApiArg = {
  siteId: number;
  trailUuid: string;
  stepId: number;
  amenitiesType:
    | "shop"
    | "tourism"
    | "food_and_drink"
    | "spring"
    | "historic"
    | "accommodation"
    | "campsite"
    | "shelter"
    | "drinking_water";
  page: number;
  lang: "it" | "en" | "en-us" | "es";
};
export type GetWaypointsApiResponse = /** status 200 OK */ WayPointSchema[];
export type GetWaypointsApiArg = {
  siteId: string;
  search?: string;
  quadhashs?: string;
  lang: "it" | "en" | "en-us" | "es";
};
export type GetWaypointApiResponse = /** status 200 OK */ WayPointDetailsSchema;
export type GetWaypointApiArg = {
  siteId: number;
  quadhash: string;
  lang: "it" | "en" | "en-us" | "es";
};
export type GetWaypointAmenitiesApiResponse =
  /** status 200 OK */ PaginateAmenitySchema;
export type GetWaypointAmenitiesApiArg = {
  siteId: number;
  quadhash: string;
  amenitiesType:
    | "shop"
    | "tourism"
    | "food_and_drink"
    | "spring"
    | "historic"
    | "accommodation"
    | "campsite"
    | "shelter"
    | "drinking_water";
  page: number;
  lang: "it" | "en" | "en-us" | "es";
};
export type GetPoiApiResponse = /** status 200 OK */ PoiSchema;
export type GetPoiApiArg = {
  siteId: number;
  id: number;
  lang: "it" | "en" | "en-us" | "es";
};
export type GetAccommodationsApiResponse =
  /** status 200 OK */ PaginateAccommodationSchema;
export type GetAccommodationsApiArg = {
  siteId: number;
  quadhash?: string;
  routeId?: string;
  trailId?: number;
  stepId?: number;
  page?: number;
  order?:
    | "relevance"
    | "cost-1"
    | "cost-2"
    | "cost-3"
    | "rating"
    | "bookable"
    | "accessibility"
    | "pets_allowed";
  availability?: string;
  lang: "it" | "en" | "en-us" | "es";
};
export type GetAccommodationApiResponse =
  /** status 200 OK */ AccommodationiDetailsSchema;
export type GetAccommodationApiArg = {
  siteId: number;
  id: number;
  availability?: string;
  lang: "it" | "en" | "en-us" | "es";
};
export type CreateTrailApiResponse = /** status 200 OK */ ActionSchema;
export type CreateTrailApiArg = {
  siteId: number;
  trailUuid: string;
  start: string;
  stop: string;
};
export type AddTrailCheckpointApiResponse = /** status 200 OK */ ActionSchema;
export type AddTrailCheckpointApiArg = {
  siteId: number;
  trailUuid: string;
  quadhash: string;
  position: number;
};
export type AddRouteCheckpointApiResponse = /** status 200 OK */ ActionSchema;
export type AddRouteCheckpointApiArg = {
  siteId: number;
  routeId: string;
  trailId: number;
  quadhash: string;
  position: number;
};
export type RemoveRouteCheckpointApiResponse =
  /** status 200 OK */ ActionSchema;
export type RemoveRouteCheckpointApiArg = {
  siteId: number;
  routeId: string;
  trailId: number;
  position: number;
};
export type SplitRouteTrailApiResponse = /** status 200 OK */ ActionSchema;
export type SplitRouteTrailApiArg = {
  siteId: number;
  routeId: string;
  trailId: number;
  quadhash: string;
  position: number;
};
export type SetRouteTrailStopApiResponse = /** status 200 OK */ ActionSchema;
export type SetRouteTrailStopApiArg = {
  siteId: number;
  routeId: string;
  trailId: number;
  quadhash: string;
};
export type SetRouteTrailStartApiResponse = /** status 200 OK */ ActionSchema;
export type SetRouteTrailStartApiArg = {
  siteId: number;
  routeId: string;
  trailId: number;
  quadhash: string;
};
export type UpdateRouteTrailCheckpointApiResponse =
  /** status 200 OK */ ActionSchema;
export type UpdateRouteTrailCheckpointApiArg = {
  siteId: number;
  routeId: string;
  trailId: number;
  quadhash: string;
  position: number;
};
export type MapSettingsSchema = {
  tiles: any[][];
  extent: any[];
  source_url: string;
};
export type ImagesSchema = {
  small: string;
  medium: string;
  large?: string;
  huge?: string;
  placeholder?: string;
  attribution?: string;
  attribution_url?: string;
  title?: string;
};
export type WayPointSchema = {
  quadhash: string;
  elevation: number;
  lnglat: any[];
  extent: any[];
  title: string;
  subtitle?: string;
  amenities: {
    [key: string]: number;
  };
};
export type RouteSchema = {
  route_id: string;
  title: string;
  subtitle?: string;
  description?: string;
  is_custom: boolean;
  image?: ImagesSchema;
  start_place: WayPointSchema;
  stop_place: WayPointSchema;
  time: number;
  difficult: number;
  length: number;
  trail_count: number;
};
export type GuideSchema = {
  id: number;
  title: string;
  subtitle?: string;
  image_url?: ImagesSchema;
  routes: RouteSchema[];
};
export type SearchResultSchema = {
  id: number;
  type: string;
  quadhash: string;
  extent: any[];
  title: string;
  subtitle?: string;
  icons?: string[];
};
export type TrailSchema = {
  uuid: string;
  trail_id: number;
  title: string;
  subtitle?: string;
  description?: string;
  start_place: WayPointSchema;
  stop_place: WayPointSchema;
  time: number;
  difficult: number;
  steps_count: number;
  length: number;
  extent: any[];
};
export type RouteDetailsSchema = {
  route_id: string;
  title: string;
  subtitle?: string;
  description?: string;
  is_custom: boolean;
  image?: ImagesSchema;
  start_place: WayPointSchema;
  stop_place: WayPointSchema;
  time: number;
  difficult: number;
  length: number;
  trail_count: number;
  trails: TrailSchema[];
  extent: any[];
};
export type RouteNearestTrailSchema = {
  trail_id?: number;
  trail_uuid?: string;
  distance_from_trail?: number;
};
export type StepSchema = {
  step_id: number;
  quadhash: string;
  waypoint_quadhashs: string[];
  title: string;
  subtitle?: string;
  time: number;
  length: number;
  deviation_length: number;
  deviation_time: number;
  elevation?: number;
  elevation_on_trail?: number;
  distance_from_trail: number;
  start_length: number;
  start_time: number;
  stop_length: number;
  stop_time: number;
  amenities: {
    [key: string]: number;
  };
  lnglat: any[];
  extent: any[];
  is_deviation: boolean;
  is_checkpoint: boolean;
  is_start_stop: boolean;
  is_alternative_stop: boolean;
};
export type TrailDetailsSchema = {
  steps: StepSchema[];
  alternative_stops: WayPointSchema[];
  is_bookable: boolean;
  accommodation_count: number;
};
export type ProfileSchema = {
  lnglat: any[];
  distance: number;
  elevation: number;
  time: number;
};
export type TrailConnectionSchema = {
  checkpoint_position?: number;
  start_length?: number;
  start_time?: number;
  stop_length?: number;
  stop_time?: number;
  step_id?: number;
};
export type StepDetailsSchema = {
  description?: string;
  images?: ImagesSchema[];
  is_bookable: boolean;
};
export type AmenitySchema = {
  id: number;
  source: string;
  quadhash: string;
  title?: string;
  subtitle?: string;
  lnglat: any[];
  extent: any[];
  image?: ImagesSchema;
};
export type AmenityList = AmenitySchema[];
export type PaginateAmenitySchema = {
  pages: number;
  has_next: boolean;
  has_previus: boolean;
  objects: AmenityList;
};
export type WayPointDetailsSchema = {
  quadhash: string;
  elevation: number;
  lnglat: any[];
  extent: any[];
  title: string;
  subtitle?: string;
  amenities: {
    [key: string]: number;
  };
  images?: ImagesSchema[];
  description?: string;
  is_bookable: boolean;
};
export type PoiSchema = {
  id: number;
  source: string;
  quadhash: string;
  title?: string;
  subtitle?: string;
  lnglat: any[];
  extent: any[];
  image?: ImagesSchema;
  elevation: number;
  description?: string;
  images?: ImagesSchema[];
};
export type AccommodationSchema = {
  id: number;
  source: string;
  quadhash: string;
  title?: string;
  subtitle?: string;
  lnglat: any[];
  extent: any[];
  image?: ImagesSchema;
  elevation: number;
  services: string[];
  ourpick?: boolean;
  cost_range: number;
  rating?: number;
  affiliate_url?: string;
  booking_url?: string;
  current_price?: string;
  message?: string;
};
export type AccommodationList = AccommodationSchema[];
export type PaginateAccommodationSchema = {
  pages: number;
  has_next: boolean;
  has_previus: boolean;
  message?: string;
  objects: AccommodationList;
};
export type AccommodationiDetailsSchema = {
  id: number;
  source: string;
  quadhash: string;
  title?: string;
  subtitle?: string;
  lnglat: any[];
  extent: any[];
  image?: ImagesSchema;
  elevation: number;
  services: string[];
  ourpick?: boolean;
  cost_range: number;
  rating?: number;
  affiliate_url?: string;
  booking_url?: string;
  current_price?: string;
  message?: string;
  place_name?: string;
  address?: string;
  description?: string;
  review?: string;
  images?: ImagesSchema[];
  cost?: string;
  contacts?: {
    [key: string]: string;
  }[];
};
export type ActionSchema = {
  data?: any;
  message?: string;
};
export const {
  useGetSiteMapsettingsQuery,
  useGetSiteGuideQuery,
  useSearchQuery,
  useGetRouteQuery,
  useGetRouteMapsettingsQuery,
  useGetRouteImagesQuery,
  useGetRouteNearestTrailQuery,
  useGetTrailQuery,
  useGetTrailImagesQuery,
  useGetTrailProfileQuery,
  useGetTrailWaypointConnectionQuery,
  useGetStepDetailsQuery,
  useGetStepAmenitiesQuery,
  useGetWaypointsQuery,
  useGetWaypointQuery,
  useGetWaypointAmenitiesQuery,
  useGetPoiQuery,
  useGetAccommodationsQuery,
  useGetAccommodationQuery,
  useCreateTrailQuery,
  useAddTrailCheckpointQuery,
  useAddRouteCheckpointQuery,
  useRemoveRouteCheckpointQuery,
  useSplitRouteTrailQuery,
  useSetRouteTrailStopQuery,
  useSetRouteTrailStartQuery,
  useUpdateRouteTrailCheckpointQuery,
} = api;
